var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttempt4Badge({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 20,
    height: 18,
    rx: 7.5,
    stroke: "#3260D4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.016 14.084C11.864 14.084 11.744 14.04 11.656 13.952C11.568 13.864 11.524 13.74 11.524 13.58V12.188H8.08C7.92 12.188 7.792 12.152 7.696 12.08C7.608 12 7.564 11.888 7.564 11.744C7.564 11.656 7.584 11.568 7.624 11.48C7.664 11.384 7.736 11.264 7.84 11.12L11.5 5.792C11.572 5.68 11.652 5.596 11.74 5.54C11.828 5.484 11.932 5.456 12.052 5.456C12.18 5.456 12.288 5.496 12.376 5.576C12.472 5.656 12.52 5.784 12.52 5.96V11.348H13.396C13.548 11.348 13.664 11.384 13.744 11.456C13.824 11.528 13.864 11.632 13.864 11.768C13.864 11.904 13.824 12.008 13.744 12.08C13.664 12.152 13.548 12.188 13.396 12.188H12.52V13.58C12.52 13.74 12.476 13.864 12.388 13.952C12.3 14.04 12.176 14.084 12.016 14.084ZM11.524 11.348V6.692H11.812L8.452 11.612V11.348H11.524Z",
    fill: "#3260D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttempt4Badge);
export default __webpack_public_path__ + "static/media/attempt-4-badge.4bb5db1019d6d0a243bee5e51e73828a.svg";
export { ForwardRef as ReactComponent };